var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAircraftIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9591 11.7422L16.5248 9.64302L15.8116 8.99083L12.2052 9.27616L9.41378 6.76932L15.4041 3.3861L14.1205 2.24478C13.3462 2.38744 7.47813 3.56953 6.07223 3.77334L2.24167 0.36974C1.69154 -0.139781 0.835778 -0.1194 0.30602 0.410501C-0.162612 1.00155 -0.0811112 1.83716 0.469022 2.34668L4.29958 5.75028C4.23846 7.19732 3.72907 13.1485 3.66795 13.9434L4.93122 15.0847L7.64113 8.74626L10.4326 11.2531L10.5548 14.8605L11.2883 15.5127L12.9591 11.7422Z",
    fill: "#BCAB79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAircraftIcon);
export default __webpack_public_path__ + "static/media/aircraft_icon.0879f15546456c77e0019119d14616c3.svg";
export { ForwardRef as ReactComponent };